import {TableConfig} from './types';

export const defaultTableConfig: TableConfig = {
    canEdit: false,
    canDelete: false,
    canCreate: false,
    withPagination: false,
    sort: {
        changeable: false,
        defaultSort: {},
    },
};
